import React from 'react';
import styled, { css } from 'styled-components';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import CheckboxSimple from './CheckboxSimple';
import { FontWeight } from 'components/Text';
import ValidationError from './ValidationError';
import Label from './Label';

const propTypes = {
    fieldName: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    label: PropTypes.string,
    row: PropTypes.bool,
};

const defaultProps = {
    fieldName: PropTypes.string,
    options: PropTypes.array,
    onChange: "",
    label: null
};

const StyledCheckbox = styled(CheckboxSimple)`
    margin-bottom: 8px;
`;

const CheckboxContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 10px;
`;

const Wrapper = styled.div`
    width: 100%;

    ${({ inline }) =>
        inline &&
        css`
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: flex-start;
    `}

    ${({ disabled }) =>
        disabled &&
        css`
        opacity: 0.3;
    `}
`;

const CheckBoxFormSectionSimple = ({
    field,
    fieldName,
    options,
    onChange,
    label,
    disabled,
    readOnly,
    isRequired,
    hideLabelAsterisk,
    validationMinHeight,
    inline,
    validation,
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const meta = {
        touched: touched[fieldName],
        error: errors[fieldName]
    };

    const optionYes = options.find(opt => opt && opt.label.toUpperCase() === 'YES')?.value || '';
    const optionNo = options.find(opt => opt && opt.label.toUpperCase() === 'NO')?.value || '';

    const onClick = () => {
        if (!field.value) {
            setFieldValue(field.name, optionYes)
            onChange(optionYes)
        } else if (field.value.idAnswerOption === optionNo.idAnswerOption) {
            setFieldValue(field.name, optionYes)
            onChange(optionYes)
        } else if (field.value.idAnswerOption === optionYes.idAnswerOption) {
            setFieldValue(field.name, optionNo)
            onChange(optionNo)
        }
    }

    return (
        <Wrapper
            inline={inline}
            disabled={disabled}
            {...props}
        >
            <CheckboxContainer inline={inline} {...props}>
                <label>
                    <Field
                        disabled={disabled}
                        readOnly={readOnly}
                        name={fieldName}
                        value={field.value}
                        component={StyledCheckbox}
                        onClick={() => onClick()}
                        checked={field.value?.idAnswerOption === optionYes?.idAnswerOption}
                    />
                </label>
            </CheckboxContainer>
            {label && (
                <Label
                    meta={meta}
                    width={inline ? 70 : null}
                    isRequired={isRequired}
                    weight={FontWeight.SemiBold}
                    inline={inline}
                    hideLabelAsterisk={hideLabelAsterisk}
                >
                    {label}
                </Label>
            )}

            <ValidationError
                style={{ minWidth: '100%' }}
                meta={meta}
                validationMinHeight={validationMinHeight}
            />

        </Wrapper>
    );
};

CheckBoxFormSectionSimple.propTypes = propTypes;
CheckBoxFormSectionSimple.defaultProps = defaultProps;

export default CheckBoxFormSectionSimple;
